import { ComponentProps, FC } from 'react';
import { useParams } from 'react-router-dom';

import { utilService } from 'services/util-service';
import Error404Page from './Error404Page';

/**
 * @param InComponent
 * @description HOC 유저 인증 컴포넌트
 * role 은 대소문자 무관하게 V / R 만 허용하고, 그 외 값은 404 로 보낸다.
 */
export const withAuthUser = (InComponent: FC) => {
  // eslint-disable-next-line
  return (props: ComponentProps<any>) => {
    const { role } = useParams();

    if (utilService.normalizeRole(role) === undefined) {
      return <Error404Page />;
    }

    return <InComponent {...props} />;
  };
};
